import { array, object, string } from 'yup';

import { isEmpty } from '@utils/common';
import { getSchema } from '@utils/schemaUtils';

import { validationErrMessages } from '@constants/validationConstants';

import { ECheckForFields as CheckForFieldsEnum } from './enum';

export const checkForFields = {
	vendor: object().nullable().required(validationErrMessages.vendor),
	sitesT_4G_FDD: array()
		.nullable()
		.default(null)
		.test('sitesT_4G_FDD', validationErrMessages.technology, (_, context) => {
			const isRestTechsIsEmpty = isEmpty(context.parent.sitesT_4G_TDD) && isEmpty(context.parent.sitesT_5G);

			if (isEmpty(context.parent.sitesT_4G_FDD) && isRestTechsIsEmpty) {
				context.createError({
					message: validationErrMessages.technology,
					path: CheckForFieldsEnum.sitesT_4G_FDD,
				});

				return false;
			}

			return true;
		}),
	sitesT_4G_TDD: array()
		.nullable()
		.default(null)
		.test('sitesT_4G_TDD', validationErrMessages.technology, (_, context) => {
			const isRestTechsIsEmpty = isEmpty(context.parent.sitesT_4G_FDD) && isEmpty(context.parent.sitesT_5G);

			if (isEmpty(context.parent.sitesT_4G_TDD) && isRestTechsIsEmpty) {
				context.createError({
					message: validationErrMessages.technology,
					path: CheckForFieldsEnum.sitesT_4G_TDD,
				});

				return false;
			}

			return true;
		}),
	sitesT_5G: array()
		.nullable()
		.default(null)
		.test('sitesT_5G', validationErrMessages.technology, (_, context) => {
			const isRestTechsIsEmpty = isEmpty(context.parent.sitesT_4G_FDD) && isEmpty(context.parent.sitesT_4G_TDD);

			if (isEmpty(context.parent.sitesT_5G) && isRestTechsIsEmpty) {
				context.createError({
					message: validationErrMessages.technology,
					path: CheckForFieldsEnum.sitesT_5G,
				});

				return false;
			}

			return true;
		}),
	kpi: array()
		.nullable()
		.default(null)
		.required(validationErrMessages.kpi).test('kpi', validationErrMessages.kpi, (value, context) => {
			if (isEmpty(value)) {
				context.createError({ message: validationErrMessages.kpi, path: CheckForFieldsEnum.kpi });

				return false;
			}

			return true;
		}),
	aggregationType: string().required(validationErrMessages.aggregationType),
};

export const checkForSchema = getSchema(checkForFields);
